import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { useSelector } from "react-redux";
import LoaderSimple from "../general/loader";
import { sheets, models, headers, common } from "./sheet";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import PropTypes from "prop-types";
import BannerNotFound from "../../assets/img/banner-notfound.png";
import { FormattedMessage, useIntl } from "react-intl";

/** API used
 *  1) business-settlement
 * */
const useDetailsPageStatus = backButtonShow => {
  const [detailsPage, setDetailsPage] = useState(false);
  const [objDetails, setObjDetails] = useState({});
  const changePage = (value, objDetails) => {
    setDetailsPage(value);
    setObjDetails(objDetails);
    if (value === true) backButtonShow();
  };
  return [detailsPage, changePage, objDetails];
};

const updateUrl = ({ navigate, model, data, addData = false }) => {
  let params = "";
  Object.keys(data).forEach(param => {
    params += `&${param}=${data[param]}`;
  });  
  if (addData) {
    navigate({
      pathname: "/reports",
      search: `?${window.location.href.split("?")[1]}${params}&detail=true`
    });
  } else {
    navigate({
      pathname: "/reports",
      search: `?model=${model}${params}`
    });
  }
};

const ReportsPage = ({
  setTitle,
  backButtonShow,
  backArrowClicked,
  model,
  setModel,  
  paramsFromUrl,
  detailOnLoad,
  setAdditionalBackSearch
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const reports = useSelector(state => state.reports);
  const [selectedSearch, setSelectedSearch] = useState(false);
  const [modelIsValid, setModelIsValid] = useState(false);
  const [detailsPage, setDetailsPage, objDetails] = useDetailsPageStatus(backButtonShow);

  const printPDF = useRef();

  const [csvData, setCsvData] = useState([]);

  const setDataReport = d => {
    let output = d?.rows;
    let lastRow = {};
    d.header.forEach(i => {
      lastRow[i] = "";
    });
    output.push(lastRow);
    output.forEach(o => {
      ["subRow", "vatRate"].forEach(e => {
        delete o[e];
      });
    });
  };

  const goToDetails = (r, addInSearch = true) => {
    let paramsForDetailsPage = {};
    const modelParams = models.find(x => x.id === model)?.detailParams || [];
    modelParams.map(param => {
      if (r[param]) {
        paramsForDetailsPage[param] = r[param];
      }
      return null;
    });
    if (addInSearch) {
      updateUrl({ navigate, data: paramsForDetailsPage, addData: true });
    }
    setDetailsPage(true, paramsForDetailsPage);
  };

  const goToNewModel = (newData, newModel) => {
    updateUrl({ navigate, model: newModel, data: newData });
    if (newData["detail"])
      setDetailsPage(true, newData);
    setModel(newModel);
  };

  const checkDetailParams = (paramsFromUrl) => {
    let detailParams = {};
    const modelParams = models.find(x => x.id === model)?.detailParams || [];
    modelParams.map(param => {
      if (detailParams && paramsFromUrl[param]) {
        return detailParams[param] = paramsFromUrl[param];
      } 
      return detailParams = false;
      
    });
    return detailParams;
  };

  useEffect(() => {
    if (detailOnLoad) {
      const detailParams = checkDetailParams(paramsFromUrl);
      if (detailParams) {
        goToDetails(detailParams, false);
      }
    }
  }, []);

  useEffect(() => {
    if (detailsPage) {
      let addBackSearch = "";
      const modelParams = models.find(x => x.id === model)?.mainParams || [];
      modelParams.map(param => {
        if (paramsFromUrl[param]) {
          addBackSearch += `&${param}=${paramsFromUrl[param]}`;
        }
        return null;
      });
      setAdditionalBackSearch(addBackSearch);
    }
  }, [detailsPage]);

  useEffect(() => {
    if (model) {
      if (models.find(x => x.id === model)) {
        setTitle("REPORT - " + models.find(x => x.id === model).text);
        setModelIsValid(true);
      } else {
        setTitle("REPORT - Model not Found");
        setModelIsValid(false);
      }
    }
  }, [model]);

  useEffect(() => {
    if (backArrowClicked) {
      setDetailsPage(false);
      if (model === "ledger" && detailsPage) {
        const params = { fromDate: objDetails.fromDate, toDate: objDetails.toDate, refYear: objDetails.refYear };
        updateUrl({ navigate, model: "balance", data: params });
        setModel("balance");
      }
    }
  }, [backArrowClicked]);

  const renderReportHeader = () => {
    if (model === "vatSettlement" && detailsPage) {
      return (
        !reports.search.status.started && (
          <headers.ReportVatSettlementSheetHeaderDetails            
            setSelectedSearch={setSelectedSearch}
            objDetails={objDetails}
            paramsFromUrl={paramsFromUrl} />
        )
      );
    }
    // Default header in other cases
    return <common.ReportCommonHeader
      modelConfig={models.find(x => x.id === model)}
      setSelectedSearch={setSelectedSearch}      
      paramsFromUrl={paramsFromUrl}
    />;
  };

  const renderSearchResult = () => {
    switch (model) {
    case "vatSettlement":
      if (detailsPage)
        return (
          <sheets.ReportVatSettlementSheetDetails
            objDetails={objDetails}
            setDataReport={setDataReport}
            setSelectedSearch={setSelectedSearch}            
            setCsvData={setCsvData}
          />
        );
      return (
        <sheets.ReportVatSettlementSheet
          goToDetails={goToDetails}
          setDataReport={setDataReport}          
          setCsvData={setCsvData}
        />
      );
    case "balance":
      return (
        <sheets.ReportBalanceSheet
          goToNewModel={goToNewModel}
          paramsFromUrl={paramsFromUrl}
          setCsvData={setCsvData} />);
    case "ledger":
      return (
        <sheets.ReportLedgerSheet
          objDetails={objDetails}
          setDataReport={setDataReport}
          setSelectedSearch={setSelectedSearch}
          paramsFromUrl={paramsFromUrl}
          setCsvData={setCsvData}
        />
      );
    default:
      return null;
    }
  };

  return (
    modelIsValid && (
      <div className="dbx-reports-root">
        {renderReportHeader()}
        <div className="dbx-reports-result">
          {selectedSearch && reports.search.status.ended && (
            <div className="dbx-reports-result-header">
              {model !== "balance" && <CSVLink
                data={csvData}
                filename={
                  new Date().toDateString().replaceAll(" ", "_") + ".csv"
                }
              >
                <FontAwesomeIcon
                  icon={["far", "download"]}
                  style={{
                    marginRight: 10,
                    color: "#0090d1",
                    cursor: "pointer"
                  }}
                  title={intl.formatMessage({id: "reports.downloadCsv" })}
                />
              </CSVLink>}
              <ReactToPrint
                trigger={() => (
                  <FontAwesomeIcon
                    icon={["far", "print"]}
                    style={{
                      marginRight: 10,
                      color: "#0090d1",
                      cursor: "pointer"
                    }}
                    title={intl.formatMessage({id: "reports.printPdf" })}
                  />
                )}
                content={() => printPDF.current}
              />
            </div>
          )}
          <div className="dbx-reports-result-body" ref={printPDF}>
            {selectedSearch && reports.search.status.started && (
              <div className="dbx-reports-result loading">
                <LoaderSimple message="Caricamento dati in corso...." />
              </div>
            )}
            {renderSearchResult()}
            {selectedSearch && reports.search.status.error && (
              <div className="dbx-reports-result-notfound">
                <div><img src={BannerNotFound} alt="" /></div>
                <div><FormattedMessage id="reports.resultNotFound" /></div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

ReportsPage.propTypes = {
  setTitle: PropTypes.func.isRequired,
  backButtonShow: PropTypes.func.isRequired,
  backArrowClicked: PropTypes.bool.isRequired,
  model: PropTypes.string.isRequired
};

export default ReportsPage;
